/* CYRA "Added to your bag" panel.
   Added 3 Oct 2026. Shows a clear confirmation after Add to Bag on product pages:
   the item, the free-shipping status and View bag / Checkout buttons.
   Listens to /cart/add requests, so cyra-product.js stays unchanged. */
(function () {
  if (window.__cyraAddedPanel) return;
  window.__cyraAddedPanel = true;

  var FREE = 7500;
  var timer = null;

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (ch) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]; }); }

  var css = '' +
    '.cyra-ap{position:fixed;top:16px;right:16px;z-index:2147483000;width:360px;max-width:calc(100vw - 32px);background:#fff;border:1px solid #E6DED3;box-shadow:0 12px 40px rgba(36,26,23,.18);padding:18px;font-size:13px;line-height:1.45;color:#241A17;transform:translateY(-12px);opacity:0;transition:opacity .2s ease,transform .2s ease;pointer-events:none}' +
    '.cyra-ap.is-open{opacity:1;transform:none;pointer-events:auto}' +
    '.cyra-ap__head{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;font-size:12px;letter-spacing:.12em;text-transform:uppercase}' +
    '.cyra-ap__close{background:none;border:0;font-size:20px;line-height:1;cursor:pointer;color:#241A17;padding:0 2px}' +
    '.cyra-ap__item{display:flex;gap:12px;align-items:center}' +
    '.cyra-ap__item img{width:64px;height:80px;object-fit:cover;background:#F6F3EE;flex:none}' +
    '.cyra-ap__title{font-weight:600;margin:0}' +
    '.cyra-ap__meta{margin:2px 0 0;color:#6B5E57}' +
    '.cyra-ap__ship{margin:14px 0 0;padding:10px 12px;background:#F6F3EE}' +
    '.cyra-ap__bar{margin-top:6px;height:4px;background:#E6DED3;border-radius:2px;overflow:hidden}' +
    '.cyra-ap__bar span{display:block;height:100%;background:#8B6F5E}' +
    '.cyra-ap__btns{display:flex;gap:8px;margin-top:14px}' +
    '.cyra-ap__btns a{flex:1;text-align:center;padding:12px 8px;font-size:12px;letter-spacing:.12em;text-transform:uppercase;text-decoration:none}' +
    '.cyra-ap__view{border:1px solid #241A17;color:#241A17}' +
    '.cyra-ap__go{background:#241A17;color:#fff;border:1px solid #241A17}' +
    '@media (max-width:480px){.cyra-ap{top:auto;bottom:12px;right:12px;left:12px;width:auto;max-width:none}}';

  function ensure() {
    var el = document.getElementById('cyra-added-panel');
    if (el) return el;
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);
    el = document.createElement('div');
    el.id = 'cyra-added-panel';
    el.className = 'cyra-ap';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-label', 'Added to your bag');
    document.body.appendChild(el);
    el.addEventListener('mouseenter', function () { clearTimeout(timer); });
    el.addEventListener('click', function (e) { if (e.target.closest('.cyra-ap__close')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return el;
  }

  function close() {
    var el = document.getElementById('cyra-added-panel');
    if (el) el.classList.remove('is-open');
    clearTimeout(timer);
  }

  function show(item, cart) {
    var el = ensure();
    var img = item.image ? String(item.image) : '';
    var total = cart ? cart.total_price : item.final_line_price;
    var ship = total >= FREE
      ? 'You’ve unlocked free US shipping.'
      : 'You’re ' + money(FREE - total) + ' away from free US shipping.';
    var w = Math.min(100, Math.round(total / FREE * 100));
    el.innerHTML =
      '<div class="cyra-ap__head"><span>Added to your bag ✓</span><button type="button" class="cyra-ap__close" aria-label="Close">×</button></div>' +
      '<div class="cyra-ap__item">' +
        (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="">' : '') +
        '<div><p class="cyra-ap__title">' + esc(item.product_title) + '</p>' +
        (item.variant_title ? '<p class="cyra-ap__meta">' + esc(item.variant_title) + '</p>' : '') +
        '<p class="cyra-ap__meta">' + money(item.final_line_price) + (item.quantity > 1 ? ' · Qty ' + item.quantity : '') + '</p></div>' +
      '</div>' +
      '<div class="cyra-ap__ship">' + ship + '<div class="cyra-ap__bar"><span style="width:' + w + '%"></span></div></div>' +
      '<div class="cyra-ap__btns"><a class="cyra-ap__view" href="/cart">View bag' + (cart ? ' (' + cart.item_count + ')' : '') + '</a><a class="cyra-ap__go" href="/checkout">Checkout</a></div>';
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    clearTimeout(timer);
    timer = setTimeout(close, 9000);
  }

  var _f = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = typeof a === 'string' ? a : (a && a.url) || '';
    var p = _f.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) {
        if (!res || !res.ok) return;
        res.clone().json().then(function (data) {
          var item = data && data.items ? data.items[data.items.length - 1] : data;
          if (!item || !item.product_title) return;
          _f('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) { show(item, cart); })
            .catch(function () { show(item, null); });
        }).catch(function () {});
      }).catch(function () {});
    }
    return p;
  };
})();
